import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Nav } from '../Nav/Nav';
import { MenuButton } from '../MenuButton/MenuButton';
import { LoginButton } from '../LoginButton/LoginButton';
import { AuthState, useAuth } from '../../../features/auth/AuthProvider';

import logo from '../../../assets/png/230110_everylive_oneline.png';
import './AppBar.scss';
import { UserInfo } from '../UserInfo/UserInfo';

export const AppBar = (): ReactElement => {
  const history = useHistory();
  const { isAuthenticated } = useAuth() as AuthState;

  const handleLogoClick = (): void => {
    history.push('/');
  };

  return (
    <header className="app-bar">
      <div className="container-fluid app-bar__container">
        <MenuButton />
        <img
          className="logo"
          src={logo}
          style={{ cursor: 'pointer' }}
          onClick={handleLogoClick}
        />
        <Nav />

        {isAuthenticated ? <UserInfo /> : <LoginButton />}
      </div>
    </header>
  );
};
